
import React, { useEffect, useState } from "react";
import { Form, Select, Input, Button, InputNumber, message, Space } from 'antd';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function InstallmentFilter() {
    const reports = useReportsStore();
    const { getBranchNames, business } = usePersistedStore();
    const businessToken = business.currentBusiness.token;
    const branchNames = business.branchNames.data;
    const branchNamesLoading = business.branchNames.loading;
    const loading = reports.installment.loading;

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [branchIds, setBranchIds] = useState([]);
    const [username, setUsername] = useState("");
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);

    useEffect(() => {
        if (businessToken) {
            getBranchNames(businessToken);
        }
    }, [businessToken, getBranchNames]);

    useEffect(() => {
        const filter = reports.installment.filter || {};
        setBranchIds(filter.branchIds || []);
        setUsername(filter.username || "");
        setPageSize(filter.pageSize || 10);
        setPageIndex((filter.pageIndex ?? 0) + 1);
    }, [reports.installment.filter]);

    const convertToISOString = (date) => {
        if (!date) return null;
        const jsDate = date.toDate ? date.toDate() : date;
        return jsDate instanceof Date ? jsDate.toISOString() : null;
    };

    const handleSearch = () => {
        if (fromDate && toDate && fromDate.toDate() > toDate.toDate()) {
            return message.error("تاریخ شروع نمی‌تواند بعد از تاریخ پایان باشد.");
        }

        const param = {};
        if (fromDate) param.fromDate = convertToISOString(fromDate);
        if (toDate) param.toDate = convertToISOString(toDate);
        if (branchIds && branchIds.length > 0) param.branchIds = branchIds;
        if (username?.trim()) param.username = username.trim();
        param.pageSize = pageSize;
        param.pageIndex = pageIndex > 0 ? pageIndex - 1 : 0;

        reports.getInstallmentInfo({ param });
    };

    const handleReset = () => {
        setFromDate(null);
        setToDate(null);
        setBranchIds([]);
        setUsername("");
        setPageSize(10);
        setPageIndex(1);
        reports.clearInstallmentData();
    };

    return (
        <div className="mb-2">
            <Form layout="inline" className="grid grid-rows-1 mb-2"
            onFinish={handleSearch}
            style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%'}}
             >
                <Form.Item label="رشته بیمه">
                    <Select
                        mode="multiple"
                        allowClear
                        value={branchIds}
                        onChange={setBranchIds}
                        loading={branchNamesLoading}
                        disabled={branchNamesLoading}
                        style={{ minWidth: 250 }}
                        placeholder="انتخاب رشته بیمه"
                    >
                        {branchNames?.filter(name => !name.Disabled).map(name => (
                            <Select.Option key={name.Id} value={name.Id}>{name.Title}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="نام کاربری">
                    <Input
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="نام کاربری"
                        style={{ minWidth: 180 }}
                    />
                </Form.Item>
                <div>{" "}</div>
                <Form.Item label="از تاریخ">
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item label="تا تاریخ">
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                
                <Form.Item label="شماره صفحه">
                    <InputNumber
                        min={1}
                        value={pageIndex}
                        onChange={(value) => setPageIndex(value || 1)}
                        style={{ width: 100 }}
                    />
                </Form.Item>
                <Form.Item label="تعداد در صفحه">
                    <Select value={pageSize} onChange={setPageSize} style={{ width: 100 }}>
                        {Array(4).fill(0).map((_, i) => {
                            const size = (i + 1) * 25;
                            return (
                                <Select.Option key={size} value={size}>
                                    {size}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <div className="mt-4"><Space>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            جستجو
                        </Button>
                        <Button onClick={handleReset}>
                            پاک کردن
                        </Button>
                    </Space></div>
                </Form.Item>
            </Form>
        </div>
    );
}
